<template>
  <div class="inter-group">
    <van-cell v-for="item in groupList" :key="item.id" :title="item.name" @click="handleDetail(item.id)">
      <van-icon class="reply-open" :name="replyOpenImg" />
    </van-cell>
  </div>
</template>
<script>
import { selGroup } from "@/server/api.js";
import { addressBar } from "./js/config";
import { Toast } from "vant";
export default {
  data() {
    return {
      groupList: [],
      replyOpenImg: require("../../assets/images/replyopen.png"),
      windowurl: window.location.href.split("#")[0] || "https://xyqw.xinyuanhulian.com/reply",
      jsList: ["getCurExternalContact", "sendChatMessage"],
    };
  },
  // props: {
  //   wechatUserId: {
  //     type: String,
  //     default: "",
  //   },
  // },
  // watch: {
  //   wechatUserId: {
  //     handler(val) {
  //       if (!val) {
  //           this.getWechatId();
  //       }
  //     },
  //     deep: true,
  //   },
  // },
  mounted() {
    if (!localStorage.getItem("token")) {
      addressBar("token", this.windowurl);
    }
  },
  methods: {
    // getWechatId() {
    //   let that = this;
    //   wx.invoke("getCurExternalContact", {}, function (res) {
    //     alert(JSON.stringify(res));
    //     if (res.userId) {
    //       that.wechatUserId = res.userId;
    //     }
    //   });
    // },
    interGroup() {
      selGroup().then((res) => {
        if (res.code !== "200") return Toast.fail(res.msg);
        this.groupList = res.data;
      });
    },
    handleDetail(id) {
      this.$router.push({ path: "/interTab", query: { id } });
    },
  },
};
</script>
<style lang="less" scoped>
.inter-group {
  .van-cell {
    line-height: 60px;
  }
  .van-cell__title {
    font-size: 26px;
  }
  .reply-open {
    img {
      width: 15px;
    }
  }
}
</style>
